export default "__VITE_ASSET__CSaJpYXs__"